export const environment = {
  customer_max_age: 65,
  production: true,
  itemsPerPage : 25,
  pingInterval: 5,
  API_URL: 'https://api.techfino.in/api/v1/'
};
